import { Constant } from "../../../../../../../constant"

const { CHECK_SELECTED_LANG } = Constant
export const format = CHECK_SELECTED_LANG ? "YYYY年MM月DD日" : "YYYY/MM/DD"
